import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/cargaGlobal'
import '@/libs/sweet-alerts'
import infiniteScroll from 'vue-infinite-scroll'

import BootstrapVue from 'bootstrap-vue'

import VueApexCharts from 'vue-apexcharts'

import VueSocketIO from 'vue-socket.io'

Vue.use({
    install(Vue, options) {
        Vue.component('apexchart', VueApexCharts)
    }
})



// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

Vue.use(infiniteScroll)
Vue.use(BootstrapVue);

/*Vue.use(new VueSocketIO({
    debug: false,
    //connection: 'http://192.168.18.203:3000',
    connection: 'https://harber-sockets-1972b8eae2b1.herokuapp.com',
    //connection: 'http://192.168.1.50:3000:',
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
    options: {
        withCredentials: true
    }
}))*/

//connection: 'http://192.168.1.63:3000',
//connection: 'https://harber-sockets-1972b8eae2b1.herokuapp.com',
//connection: 'https://harber-erp-api.herokuapp.com:3000',
//connection: 'http://localhost:3000',
//connection: 'http://192.168.1.34:3000',
//connection: 'http://192.168.1.34:3015',
//connection: 'http://192.168.1.34:4015',
//https://harber-sockets-1972b8eae2b1.herokuapp.com/
//connection: 'https://harber-sockets-1972b8eae2b1.herokuapp.com:4015',
//connection: 'http://192.168.1.63:4015',

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')